import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-gray-50" data-id="element-107">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-blue-100 text-center relative overflow-hidden" data-id="element-108">
        <div className="absolute top-0 right-0 -mt-10 -mr-10 text-blue-50 opacity-50 pointer-events-none" data-id="element-109">
          <ShieldCheckIcon className="w-64 h-64" data-id="element-110" />
        </div>

        <div className="relative z-10" data-id="element-111">
          <div className="inline-flex items-center justify-center p-4 bg-blue-100 rounded-full mb-6" data-id="element-112">
            <ShieldCheckIcon className="w-12 h-12 text-blue-600" data-id="element-113" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-114">
            Garanzia Soddisfatti o Rimborsati 7 Giorni
          </h2>

          <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-115">
            Puoi provare il Mega-Pack senza alcun rischio. Hai 7 giorni di tempo
            per testare i materiali, leggere i libri e valutare i bonus.
          </p>

          <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-116">
            Se per qualsiasi motivo non sei soddisfatto, puoi richiedere il
            rimborso completo.{' '}
            <strong className="text-gray-900" data-id="element-117">
              Restituzione del denaro senza domande.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}